import { loadConnectorSchema } from "./loadConnectorSchema";
import { useSemanticModelStore } from "../SemanticModelProvider";
import { reconcileSemanticModel } from "./reconcileSemanticModel";

export const refreshSchema = async (connectorId: string) => {
  useSemanticModelStore.setState(
    (state) => {
      state.isLoadingSchema = true;
    },
    false,
    "schema/refresh_db_schema_start",
  );
  try {
    const data = await loadConnectorSchema(connectorId);
    useSemanticModelStore.setState(
      (state) => {
        state.dbSchema = data || null;
      },
      false,
      "schema/refresh_db_schema",
    );
    reconcileSemanticModel();
  } finally {
    useSemanticModelStore.setState(
      (state) => {
        state.isLoadingSchema = false;
      },
      false,
      "schema/refresh_db_schema_complete",
    );
  }
};
